import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormDrawerComponent } from '@shared/components/page-layout/drawers/form-drawer/form-drawer.component';
import { PageLayoutService } from '@shared/components/page-layout/page-layout.service';
import { ParentDrawerRequest } from '@shared/components/page-layout/page-layout.types';

@Component({
    selector: 'custom-formly-field-button',
    template: `
    <button mat-icon-button class="cta-main" [matTooltip]="this.field?.props?.label" (click)="handleButtonClick()">
      <mat-icon class="text-white mr-0">{{this.field?.props?.icon}}</mat-icon>
    </button>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconButton, MatTooltip, MatIcon]
})
export class ButtonTypeComponent extends FieldType<FieldTypeConfig> {
  private layoutService = inject(PageLayoutService);


  handleButtonClick() {
    if (this.field?.props?.buttonKey !== "addRoom") return;
    
    const projectFolderIdField = this.field.parent?.fieldGroup?.find(f => f.key === 'projectFolderId');
    const projectFolderId = projectFolderIdField?.props?.options || [];
    
    this.layoutService.navigateParentDrawer({
      component: FormDrawerComponent,
      data: {
        formUrl: 'project-folder',
        skipApi: true,
        model: { addRoom: true },
        idField: 'id',
        dictionary: { projectFolderId }
      },
      smallDrawer: true,
      title: 'Add Room'
    } as ParentDrawerRequest);
  }
}
